import React, { useState, useEffect } from "react"
import styled from "styled-components"
import NextImg from "./NextImg/index"
import BannerImageLine from "@/common/assets/image/Mainpage/Banner/lines.svg"
import BannerImageLeft from "@/common/assets/image/Mainpage/Banner/left.svg"
import BannerImageRight from "@/common/assets/image/Mainpage/Banner/right.svg"

const BannerAnimation = ({ SreenWidth }) => {
  const [Active, setActive] = useState()
  useEffect(() => {
    setTimeout(() => {
      setActive("active")
    }, 300)
  }, [])

  return (
    <Wrapper>
      <BannerItems>
        {SreenWidth > 768 && (
          <>
            <LinesWrapper className={Active}>
              <NextImg src={BannerImageLine} alt="BannerImageLine" />
            </LinesWrapper>
          </>
        )}
        <LeftImageWrapper className={Active}>
          <NextImg src={BannerImageLeft} />
        </LeftImageWrapper>
        <RightImageWrapper className={Active}>
          <NextImg src={BannerImageRight} />
        </RightImageWrapper>
      </BannerItems>
    </Wrapper>
  )
}

export default BannerAnimation

const Wrapper = styled.div`
  width: 100%;
  position: absolute;
  height: 100%;
  top: 0;
  z-index: -1;
  @keyframes line {
    0% {
      transform: skewX(10deg) scale(1) rotate(15deg);
    }
    100% {
      transform: scale(1.2) rotate(-15deg);
    }
  }

  @keyframes spinImage {
    0% {
      transform: translateY(-5%) scaleY(1);
    }
    50% {
      transform: translateY(0%) scaleY(1.2) rotate(10deg);
    }

    100% {
      transform: translateY(-5%) scaleY(1);
    }
  }
  .visible {
    span {
      overflow: visible !important;
    }
  }

  img {
    position: absolute;

    will-change: transform opacity;

    &.line {
    }
  }
`

const BannerItems = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  span {
    overflow: visible !important;
  }
`

const LinesWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: clamp(350px, 120%, 4000px);
  transform: translate(-50%, -50%) scale(0.5);
  transition: all 1s ease-in-out;
  opacity: 0;
  &.active {
    will-change: transform opacity;
    transform: translate(-50%, -50%) scale(1);
    img {
      animation: line 30s ease-in-out infinite alternate-reverse;
    }
    opacity: 1;
  }
`

const RightImageWrapper = styled.div`
  width: 40%;
  position: absolute;
  left: 85%;
  z-index: 0;
  top: 50%;
  will-change: transform opacity;
  transition: all 1.5s ease-in-out;
  transform: translate(0%, -50%) scale(0.5);
  opacity: 0;
  &.active {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  @media (max-width: 600px) {
    width: 70%;
    left: 105%;
    opacity: 0.7;
  }
  img {
    animation: spinImage 30s ease-in-out infinite alternate-reverse;
  }
`
const LeftImageWrapper = styled.div`
  width: 40%;
  position: absolute;
  left: 15%;
  z-index: 0;
  top: 50%;
  transition: all 1.5s ease-in-out;
  will-change: transform opacity;
  transform: translate(-100%, -50%) scale(0.5);
  opacity: 0;
  &.active {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  @media (max-width: 600px) {
    width: 70%;
    left: -5%;
    opacity: 0.7;
  }
  img {
    animation: spinImage 30s ease-in-out infinite alternate-reverse;
  }
`
